/* eslint-disable max-lines */
import { BIZ_CODE, MEMBER_TAGS_ENUM, TIME_TAG } from '@/common/constants';
import { STRONG_CONTROL_CODE } from '@/routes/Claim/config/constants';
import { isEmptyValue, isObject, isOneOfTheseValues } from '@/utils/judgment';
import { query } from '@/utils/request';
import type { WrappedFormUtils } from '@zcy/doraemon/lib/form/Form';
import { formatCentToYuan } from '@zcy/util-store';
import { isJSON } from '@zcy/utils';
import { mpSdk } from '@zcy/zlb-utils';
import axios from 'axios';
import { message, notification, Upload } from 'doraemon';
import {
  cloneDeep,
  flatten,
  get,
  groupBy,
  intersection,
  isNil,
  mapKeys,
  pickBy,
  union,
  uniq,
} from 'lodash';
import isEmptyFromLodash from 'lodash/isEmpty';
import moment from 'moment';
import NP from 'number-precision';
import printJS from 'print-js';
import { parse } from 'qs';
import { printUserLog } from 'src/services/user';
import { v4 as uuidv4 } from 'uuid';
/**
 * 工具类函数文件
 */

function getRelation(str1, str2) {
  if (str1 === str2) {
    console.warn('Two path are equal!'); // eslint-disable-line
  }
  const arr1 = str1?.split('/');
  const arr2 = str2?.split('/');
  if (arr2.every((item, index) => item === arr1[index])) {
    return 1;
  } else if (arr1.every((item, index) => item === arr2[index])) {
    return 2;
  }
  return 3;
}

export const isIE = ver => {
  const b = document.createElement('b');
  b.innerHTML = `<!--[if IE ${ver}]><i></i><![endif]-->`;
  return b.getElementsByTagName('i').length === 1;
};

function getRenderArr(routes) {
  let renderArr = [];
  renderArr.push(routes[0]);
  for (let i = 1; i < routes.length; i += 1) {
    let isAdd = false;
    // 是否包含
    isAdd = renderArr.every(item => getRelation(item, routes[i]) === 3);
    // 去重
    renderArr = renderArr.filter(item => getRelation(item, routes[i]) !== 1);
    if (isAdd) {
      renderArr.push(routes[i]);
    }
  }
  return renderArr;
}

/**
 * Get router routing configuration
 * { path:{name,...param}}=>Array<{name,path ...param}>
 * @param {string} path
 * @param {routerData} routerData
 */
export function getRoutes(path, routerData) {
  let routes = Object.keys(routerData).filter(
    routePath => routePath.indexOf(path) === 0 && routePath !== path,
  );

  routes = routes?.map(item => item.replace(path, ''));

  const renderArr = getRenderArr(routes);

  const renderRoutes = renderArr?.map(item => {
    const exact = !routes.some(route => route !== item && getRelation(route, item) === 1);
    return {
      ...routerData[`${path}${item}`],
      key: `${path}${item}`,
      path: `${path}${item}`,
      exact,
    };
  });
  return renderRoutes;
}

/**
 * 获取url参数的方法
 * @param qs
 * @returns {{}}
 */
export function getQueryParams(qs) {
  const params = {};
  const re = /[?&]?([^=]+)=([^&]*)/g;
  let tokens;
  if (qs) {
    qs = qs?.split('+')?.join(' ');

    while ((tokens = re.exec(qs))) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
  }
  return params;
}

function transDate(day) {
  return day < 10 ? `0${day}` : `${day}`;
}

function transWeek(week) {
  const desc = {
    1: '星期一',
    2: '星期二',
    3: '星期三',
    4: '星期四',
    5: '星期五',
    6: '星期六',
    0: '星期日',
  };
  return desc[week];
}

export function getCurrentDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = transDate(date.getMonth() + 1);
  const day = transDate(date.getDate());
  const week = transWeek(date.getDay());
  return `欢迎你！今天是${year}年${month}月${day}日,${week}`;
}

let throttle = null;

export function debounce(fn, delay) {
  function setTime(args) {
    const context = this; // 获取函数所在作用域this
    if (throttle) {
      clearTimeout(throttle);
    }
    throttle = setTimeout(fn.bind(context, args), delay);
  }

  return setTime();
}

const qs = require('qs');

export const request = (url, option = {}) =>
  new Promise((resolve, reject) => {
    const options = {
      method: option.method || 'GET',
      headers: { 'content-type': option.contentType || 'application/json' },
      // headers: { 'content-type': 'application/x-www-form-urlencoded' },
      data: option.contentType
        ? qs.stringify(option.params || option.data || '')
        : option.params || option.data || '',
      url,
    };
    axios(options).then(res => {
      const { status, data } = res;
      if (status === 200 && data.success) {
        resolve(data.result);
      } else {
        message.error(data.message || data.error);
        reject(data);
      }
    });
  });

/**
 * flat兼容处理
 * @param {Array} arr
 * @returns
 */
export function flat(arr) {
  let newArr = [];
  for (let i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      newArr = newArr.concat(flat(arr[i]));
    } else {
      newArr.push(arr[i]);
    }
  }
  return newArr;
}

export function flatTreeChildren(arr) {
  let newArr = [];
  for (let i = 0; i < arr.length; i++) {
    const { children, ...rest } = arr[i] || {};
    if (children?.length) {
      newArr = newArr.concat(flatTreeChildren(children));
    } else {
      newArr.push(rest);
    }
  }
  return newArr;
}

/**
 * 全量树key归纳
 * @param {Object} gData 全量树
 * @param {Boolean} resType 返回类型
 * @returns {Array} 全量树key结果
 */
export const getAllKays = (gData, resType = false) => {
  const allTypeArray = [];
  const allTypeObject = {};
  const loop = data => {
    return data?.map(item => {
      const { key, id } = item;
      if (resType) {
        allTypeObject[key] = item;
      } else {
        allTypeArray.push(key || `${id}`);
      }
      if (item.children) {
        loop(item.children);
      }
    });
  };
  Array.isArray(gData) && loop(gData);
  return resType ? allTypeObject : allTypeArray;
};

/**
 * 全量树Key归纳(Code)
 * @param {Object} gData 全量树
 * @param {Boolean} resType 返回类型
 * @returns {Array} 全量树key结果
 */
export const getAllCodes = (gData, resType = false) => {
  const allTypeArray = [];
  const allTypeObject = {};
  const loop = data => {
    return data?.map(item => {
      const { key, code } = item;
      if (resType) {
        allTypeObject[key] = item;
      } else {
        allTypeArray.push(key || `${code}`);
      }
      if (item.children) {
        loop(item.children);
      }
    });
  };
  Array.isArray(gData) && loop(gData);
  return resType ? allTypeObject : allTypeArray;
};

export const whetherReplenish = (beginTimes = []) => {
  return beginTimes.some(i => {
    const morning = moment({ hour: 0 }).valueOf();
    const afternoon = moment({ hour: 12 }).valueOf();
    const hour = moment().hour().valueOf();
    return hour > 12 ? afternoon > i : morning > i;
  });
};

/**
 * 时间段重叠判断
 * @param beginTime1
 * @param endTime1
 * @param beginTime2
 * @param endTime2
 */
export const isTimeCross = (beginTime1, endTime1, beginTime2, endTime2) => {
  if (beginTime2 - beginTime1 > 0) {
    if (beginTime2 > endTime1) {
      return false;
    }
    return true;
  }
  if (beginTime1 > endTime2) {
    return false;
  }
  return true;
};

/**
 * 行程冲突 同时间段、同人员, 不可有两个行程
 * @param {array} 行程list
 * @return {boolean} 是否需要后补申请原因
 */
export const getItineraryConflictList = (array = []) => {
  const formatList = array?.map(i => {
    const { accompanyList, beginTime, endTime, itineraryCode, indexNo } = i;
    return accompanyList?.map(val => ({
      ...val,
      beginTime,
      endTime,
      itineraryCode: itineraryCode || indexNo,
    }));
  });
  const newFormatList = flatten(formatList);

  const groupByOperatorId = groupBy(newFormatList, 'operatorId');
  const conflictInfos = {};
  const conflictWarningInfo = {};
  const intersectionComparator = items => {
    // 长度小于等于一 无需比较
    if (!items.length || items.length <= 1) {
      return;
    }
    items.sort((a, b) => a.beginTime - b.beginTime);
    const n = items.length;
    /**
     * 由于已经排序 --- 按开始时间排序 两个个条件冲突
     * 1.第一段的结束时间 >= 第二段的开始时间
     * 2.(第一段的开始时间等于第二段的开始时间 与 第一段的结束时间等于第二段的结束时间)
     */
    if (!Array.isArray) {
      Array.isArray = obj => {
        return Array.prototype.isprototype(obj);
      };
    }
    for (let i = 0; i < n; i++) {
      for (let j = i + 1; j < n; j++) {
        const flag =
          items[i].endTime >= items[j].beginTime ||
          (items[i].beginTime === items[j].beginTime && items[i].endTime === items[j].endTime);
        if (flag) {
          const { userName, realName, beginTime, endTime } = items[i];
          const { itineraryCode } = items[j];
          const info = `${userName || realName}在${moment(beginTime).format(
            'YYYY-MM-DD',
          )}至${moment(endTime).format('YYYY-MM-DD')} 期间存在行程`;
          if (conflictInfos[itineraryCode] && Array.isArray(conflictInfos[itineraryCode])) {
            conflictInfos[itineraryCode].push(info);
          } else {
            conflictInfos[itineraryCode] = [info];
          }
        }
      }
    }
  };
  Object.keys(groupByOperatorId)?.forEach(key => {
    const value = groupByOperatorId[key];
    intersectionComparator(value);
  });
  Object.keys(conflictInfos)?.forEach(key => {
    const value = conflictInfos[key];
    conflictWarningInfo[key] = `行程冲突。${value?.join('，') || '-'}。`;
  });
  return [conflictWarningInfo, conflictInfos];
};

const fixTo3 = double => {
  double = double.toString();
  if (double.includes('.')) {
    const [digit, decimal] = double?.split('.');
    if (digit.length > 2) {
      return digit;
    } else if (digit.length + decimal.length < 4) {
      return double.padEnd(4, '0');
    }
    return parseFloat(double).toFixed(3 - digit.length);
  }
  return double.length < 3 ? `${double}.`.padEnd(4, '0') : double;
};
export const formatSize = size => {
  if (size > 1e12) {
    return `${fixTo3(size / 1099511627776)}T`;
  } else if (size > 1e9) {
    return `${fixTo3(size / 1073741824)}G`;
  } else if (size > 1e6) {
    return `${fixTo3(size / 1048576)}M`;
  } else if (size > 1e3) {
    return `${fixTo3(size / 1024)}K`;
  }
  return `${size}B`;
};

/**
 * 日期差
 */
export function diffDay(start, end) {
  // eslint-disable-next-line no-mixed-operators
  const diff = new Date(end) - new Date(start) + 1;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

// // 判断钉钉环境
// export const isDingEnv = (() => {
//   const u = navigator.userAgent.toLowerCase();
//   const { dd, zzd } = window as any;
//   return u.indexOf('dingtalk') !== -1 || typeof zzd?.getUserAgent() === 'object';
// })();

// 获取谁赢style
export const getWatermaskStyle = ({
  content = '水印',
  rotate = -15,
  zIndex = -1,
  fontSize = 14,
  style,
}) => {
  const svgStr = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' style='transform: rotate(${rotate}deg)'%3E%3Ctext x='50%25' y='50%25' font-size='${fontSize}' fill='%23a2a9b6' font-family='system-ui, sans-serif' text-anchor='middle' dominant-baseline='middle'%3E${content}%3C/text%3E%3C/svg%3E`;
  const backgroundUrl = `url("${svgStr}")`;
  return {
    zIndex,
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    backgroundRepeat: 'repeat',
    backgroundSize: '180px',
    backgroundImage: backgroundUrl,
    opacity: '0.3',
    ...style,
  };
};

export function getCurrentYearList(params?: any) {
  // nextyear 表示往后多获取一年
  const { nextYear } = params || {};
  const currentYear = new Date().getFullYear();
  const yearList = [];
  for (let i = 2021; i < currentYear + 1; i++) {
    yearList.push(i);
    if (i === currentYear && nextYear) {
      yearList.push(i + 1);
    }
  }
  return {
    currentYear,
    yearList,
  };
}

export function getCurrentOneYearAfterList() {
  const currentYear = new Date().getFullYear();
  const yearList = [];
  for (let i = 2021; i <= currentYear + 1; i++) {
    yearList.push(i);
  }
  return {
    currentYear,
    yearList,
  };
}

export function isOfdOrPdf(file) {
  try {
    return file?.toLowerCase()?.includes('ofd') || file?.toLowerCase()?.includes('pdf');
  } catch (e) {
    return false;
  }
}

/**
 * 判断值是否为空
 */
export function isEmpty(num) {
  if (typeof num === 'number') {
    return false;
  }
  return true;
}

export const defaultValue = function (value) {
  if (isEmptyValue(value)) {
    return undefined;
  } else {
    return value;
  }
};

export const filterEmptyValueInObject = function (object) {
  if (isObject(object)) {
    for (const key in object) {
      const value = object[key];
      if (isOneOfTheseValues(value, [NaN, undefined, null, ''])) {
        delete object[key];
      }
    }
    return object;
  }
};
export function isSameDay(ts1, ts2) {
  return moment(ts1).format('YYYY-MM-DD') === moment(ts2).format('YYYY-MM-DD');
}

export function loadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.crossOrigin = '';
    img.onload = () => {
      resolve(img);
    };
    img.onerror = err => {
      reject(err);
    };
  });
}

/**
 * 埋点方法['c831225', 'd7435571']
 */
export const addSpm = (params, pageBlock, event = 'event') => {
  const g_UTM = window.g_UTM || { send: () => {} };
  const { operatorId } = window?.currentUserIdentity || {};
  try {
    g_UTM.send(event, pageBlock, { operatorId, ...params });
  } catch (e) {
    // console.log("埋点有问题", e);
  }
};

export const formateFileList = (files = []) => {
  return (files || [])?.map(file => ({
    fileId: file.fileId,
    name: file.fileName || file.name,
    size: file.fileSize || file.size,
    type: file.fileType || file.type,
  }));
};

/**
 * 获取时间戳
 * @returns
 */
export const getTimeStamp = () => {
  return {
    nowData: moment().valueOf(), // 当前时间
    threeMonthsAgo: moment().subtract(3, 'months').valueOf(), // 3个月前
    sixMonthsAgo: moment().subtract(6, 'months').valueOf(), // 6个月前
  };
};
/**
 * 获取时差（秒）
 */
export const getTimeDiff = (startTime, endTime) => {
  return (startTime - endTime) / 1000;
};
/**
 * 生成序列范围方法
 */
export const getRange = (start, end, singleSave?: boolean, step = 1) => {
  if (singleSave && !start) return [end];
  if (singleSave && !end) return [start];

  if (start === end) return [start];
  return Array.from({ length: (end - start) / step + 1 }, (_, i) => start + i * step);
};

// 18位身份证正则表达式
export const rex18 =
  /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}([0-9]|X|x)$/;
// 15位身份证正则表达式
export const rex15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/;
// 推送地址
export const rexUrl =
  /^(http|https|ftp):\/\/([a-zA-Z0-9\.\-]+(:[a-zA-Z0-9\.&amp;%\$\-]+)*@)?((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.[a-zA-Z]{2,4})(:[0-9]+)?(\/[^/][a-zA-Z0-9\.,?\'\\\\\/\+&amp;%\$#\=~_\-@]*)*$/;
// URL正则表达式
export const rexUrlCurrency =
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
// 手机号正则表达式
export const rexPhoneNumber = /^1\d{10}$/;
/**
 * 报错处理
 */
export const responseErrorHandle = res => {
  const { success, message } = res || {};
  if (!success) {
    return notification.error({ message: message || '请求出错了' });
  }
  return success;
};

/**
 * 页面跳转
 */
export const openPage = (url: string) => {
  if (!url) return;
  if (mpSdk.env.isZzd) {
    const flag = url.includes('?') ? '&' : '?';
    window?.zzd?.openLink({
      url: `${location.origin}${url}${flag}ddtab=true`,
    });
    return;
  }
  window.open(url);
};

interface IGetCurrentYearMonth {
  (type: 'yearMonth', targetTime?: number | string): { year: number; month: number };
  (type: 'year' | 'month' | 'day', targetTime?: number | string): number;
}

/**
 * 获取当前月份、年份
 */
export const getCurrentYearMonth = ((
  type: 'year' | 'month' | 'yearMonth' | 'day',
  targetTime?: number | string,
) => {
  const current = targetTime ? new Date(targetTime) : new Date();
  if (type === 'yearMonth') {
    return { year: current.getFullYear(), month: current.getMonth() + 1 };
  }
  if (type === 'year') {
    return current.getFullYear();
  }

  if (type === 'month') {
    // getMonth月份范围为：0～11
    return current.getMonth() + 1;
  }
  if (type === 'day') {
    // 新增对 'day' 类型的处理
    return current.getDate();
  }
}) as IGetCurrentYearMonth;

export const displayCover = {
  render: text => text || '-',
};

// 按时间顺序，链式调用
export class SequenceQueue {
  promise = Promise.resolve();
  excute(promise) {
    this.promise = this.promise.then(() => promise);
    return this.promise;
  }
}

/**
 * 根据文件名称后缀获取文件类型
 */
export const getFileType = (fileName: string) => {
  if (!fileName?.includes('.')) return '';
  const nameType = fileName?.split('.') || [];
  return nameType[nameType.length - 1]?.toLowerCase();
};

/**
 * 跨天展示函数：跨天年月日-年月日 不跨天：年月日-月日
 * @param startTime 起始时间
 * @param endTime  结束时间
 */
export const crossDayDisplay = (startTime, endTime, format = 'YYYY-MM-DD HH:mm') => {
  if (moment(startTime).format('YYYY-MM-DD') === moment(endTime).format('YYYY-MM-DD')) {
    return moment(startTime).format(format) + ' ~ ' + moment(endTime).format('HH:mm');
  }
  return moment(startTime).format(format) + ' ~ ' + moment(endTime).format(format);
};

/**
 * 滑动至锚点
 * @param anchorId 锚点id
 */
export const scrollToAnchor = (anchorId: string) => {
  // 找到锚点
  const anchorElement = document.getElementById(anchorId);
  // 如果对应id的锚点存在，就跳转到锚点
  if (anchorElement) {
    anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
};

/**
 * 格式化树形结构，并在每个节点添加当前节点路径
 */
export const formatTreeData = (data, parentPath = []) => {
  if (!data || data.length === 0) return [];

  const newData = data?.map(ele => {
    const currentPath = [...(parentPath || []), ele.code];
    if (ele.children && ele.children.length > 0) {
      return {
        ...ele,
        label: ele.name,
        value: ele.code,
        currentPath,
        children: formatTreeData(ele.children, currentPath),
      };
    }
    return {
      ...ele,
      label: ele.name,
      value: ele.code,
      currentPath,
    };
  });
  return newData;
};

/**
 * 将树形结构打平为对象
 * @param list
 * @returns
 */
export const flatTree2Map = list => {
  if (!list || !list.length) return {};
  const map = {};
  list?.forEach(item => {
    if (!map[item.value]) {
      map[item.value] = item;
    }
    if (item?.children?.length) {
      Object.assign(map, flatTree2Map(item.children));
    }
  });
  return map;
};

/**
 * 根据时间tag返回对应的时间点
 */
export const formatTimePoint = tag => {
  let periodValue;
  if (tag === TIME_TAG.Morning) {
    periodValue = 0;
  } else if (tag === TIME_TAG.Afternoon) {
    periodValue = 12;
  } else if (tag === TIME_TAG.Evening) {
    periodValue = 18;
  } else {
    periodValue = 0;
  }
  return periodValue;
};
/**
 * 判断文件是否是图片扩展名
 * @param fileName
 * @returns
 */
export const isImage = (fileName: string = undefined): boolean => {
  if (!fileName) {
    return false;
  }
  const imageExtensions = ['jpg', 'png', 'jpeg', 'bmp', 'gif', 'webp'];
  const extension = fileName.toLocaleLowerCase()?.split('.').pop();
  return imageExtensions.includes(extension);
};
/**
 * 判断文件是否是图片
 * @param mimeType
 * @returns
 */
export const isImageByMimeType = (mimeType = ''): boolean => {
  if (!mimeType) {
    return false;
  }
  const imageExtensions = ['jpg', 'png', 'jpeg', 'bmp', 'gif', 'webp'];
  const fileMimeType = mimeType.toLocaleLowerCase();
  let isImage = false;
  imageExtensions?.forEach(item => {
    if (fileMimeType.includes(item)) {
      isImage = true;
    }
  });
  return isImage;
};

const checkItineraryCarInfo = itinerary => {
  let res = true;
  if (itinerary.arrangeCar === 1) {
    const { arrangeCarPO } = itinerary;
    arrangeCarPO &&
      Object.keys(arrangeCarPO)?.forEach(key => {
        if (!arrangeCarPO[key] && arrangeCarPO[key] !== 0) {
          res = false;
        }
      });
  } else {
    itinerary.arrangeCar = 0;
    delete itinerary['arrangeCarPO'];
  }
  return res;
};
const checkBackEndItineraryCarInfo = itinerary => {
  let res = true;
  if (itinerary.arrangeCar === 1) {
    const { arrangeCarRO } = itinerary;
    arrangeCarRO &&
      Object.keys(arrangeCarRO)?.forEach(key => {
        if (!arrangeCarRO[key] && arrangeCarRO[key] !== 0) {
          res = false;
        }
      });
  } else {
    itinerary.arrangeCar = 0;
    delete itinerary['arrangeCarRO'];
  }
  return res;
};

export const checkItineraryItemVaild = item => {
  let r = checkItineraryCarInfo(item);
  if (!item.accommodationDay && item.accommodationDay !== 0) r = false;
  if (!item.beginTime) r = false;
  if (!item.endTime) r = false;
  if (!item.beginCityCode) r = false;
  if (!item.endCityCode?.length) r = false;
  return r;
};
export const checkBackEndItineraryItemVaild = item => {
  let r = checkBackEndItineraryCarInfo(item);
  if (!item.accommodationDay && item.accommodationDay !== 0) r = false;
  if (!item.beginTime) r = false;
  if (!item.endTime) r = false;
  if (!item.beginCityCode) r = false;
  if (!item.endCityList?.length) r = false;
  return r;
};

export const changeCodeName = (list, target) => {
  const helper = arr => {
    arr?.forEach(item => {
      item.label = item[target[0]];
      item.value = item[target[1]];
      if (item.children && item.children.length > 0) {
        changeCodeName(item.children, target);
      }
    });
  };
  helper(list);
  return list;
};

export const deepQuery = (tree, target, value) => {
  let isGet = false;
  let retNode = null;
  function deepSearch(tree, target, value) {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < tree.length; i++) {
      const item = tree[i];
      if (item.children && item.children.length > 0) {
        deepSearch(item.children, target, value);
      }
      if (value === item[target] || isGet) {
        isGet || (retNode = item);
        isGet = true;
        break;
      }
    }
  }
  deepSearch(tree, target, value);
  return retNode;
};

export const getNodeRoute = (data, targetValue, value, targetLabel?) => {
  let result = []; // 记录路径结果
  const traverse = (value, path, data) => {
    if (data.length === 0) {
      return;
    }
    for (const item of data) {
      if (targetLabel) {
        path.push({
          label: item[targetLabel],
          value: item[targetValue],
        });
      } else {
        path.push(item[targetValue]);
      }
      if (item[targetValue] === value) {
        result = [...path];
        return;
      }
      const children = Array.isArray(item.children) ? item.children : [];
      traverse(value, path, children); // 遍历
      path.pop(); // 回溯
    }
  };
  traverse(value, [], data);
  return result;
};

export const initSearchParamsFromRoute: () => [any, any] = () => {
  const search = parse(location.search?.slice(1));
  const temp = Object.keys(search)?.map(key => ({
    key,
    value: search[key],
  }));
  const searchObj = {};
  Object.keys(search)?.forEach(key => {
    searchObj[key] = search[key];
  });
  return [temp, searchObj];
};

// 笛卡尔积
export const descartes = (...rest) => {
  if (rest.length < 2) return rest[0] || [];
  return [].reduce.call(rest, (col, set) => {
    const res = [];
    col?.forEach(c => {
      set?.forEach(s => {
        const t = [].concat(Array.isArray(c) ? c : [c]);
        t.push(s);
        res.push(t);
      });
    });
    return res;
  });
};
/**
 * 下载文件
 * @param fileId id
 * @param fileName 名称
 */
export const downloadFileByFileId = async (fileId: string | number, fileName?: string) => {
  try {
    const fileUrl = await Upload.getFileUrl({
      fileId: fileId,
      bizCode: BIZ_CODE,
    });
    window.open(fileUrl);
    Promise.resolve('下载成功');
  } catch (error) {
    // eslint-disable-next-line prefer-promise-reject-errors
    Promise.reject('下载失败');
  }
};

/**
 * 过滤表情
 * @param content
 */
export const removeEmoji = (content: string) => {
  return content.replace(
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g,
    '',
  );
};

/**
 * 判断是否输入emoji表情
 * @param content
 */
// eslint-disable-next-line complexity
export const isEmojiCharacter = (content: string) => {
  for (let i = 0; i < content.length; i++) {
    const hs = content.charCodeAt(i);
    if (0xd800 <= hs && hs <= 0xdbff) {
      if (content.length > 1) {
        const ls = content.charCodeAt(i + 1);
        const uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
        if (0x1d000 <= uc && uc <= 0x1f77f) {
          return true;
        }
      }
    } else if (content.length > 1) {
      const ls = content.charCodeAt(i + 1);
      if (ls === 0x20e3) {
        return true;
      }
    } else {
      if (0x2100 <= hs && hs <= 0x27ff) {
        return true;
      } else if (0x2b05 <= hs && hs <= 0x2b07) {
        return true;
      } else if (0x2934 <= hs && hs <= 0x2935) {
        return true;
      } else if (0x3297 <= hs && hs <= 0x3299) {
        return true;
      } else if ([0xa9, 0xae, 0x303d, 0x3030, 0x2b55, 0x2b1c, 0x2b1b, 0x2b50].includes(hs)) {
        return true;
      }
    }
  }
};

/**
 * 获取当前审批节点key
 * @param workFlowData
 * @returns
 */
export const getCurrentNodeKey = workFlowData => {
  const { auditNodeList = [] } = workFlowData || {};
  const currentNode = auditNodeList?.find(item => {
    return [0, 3].includes(item.auditStatus);
  });
  const { nodeKey = undefined } = currentNode || {};
  return nodeKey;
};

/**
 * 获取JSON数据
 * @param content
 */
export const getJsonData = str => {
  if (!str) return {};
  let res = {};
  try {
    res = JSON.parse(str);
  } catch (error) {
    res = {};
  }
  return res;
};

/**
 * 过滤表情符号
 * @param e input event
 */
export const filterEmoji = e => {
  if (isEmptyFromLodash(e)) return;
  const currentDom = get(e, 'currentTarget') || {};
  if (isEmptyFromLodash(currentDom) || !get(currentDom, 'value')) return;
  currentDom.value = removeEmoji(get(currentDom, 'value'));
};
/**
 * 过滤英文号
 * @param e input event
 */
export const filterQuotation = e => {
  if (isEmptyFromLodash(e)) return;
  const currentDom = get(e, 'currentTarget') || {};
  if (isEmptyFromLodash(currentDom) || !get(currentDom, 'value')) return;
  currentDom.value = get(currentDom, 'value').replace(/"/g, '“');
  // currentDom.value = get(currentDom,'value')?.replace(/"([^"]*)"/g ,"“$1”");
};

/**
 * 获取用户行为信息
 * @param {*} actionType 操作类型：1-登录，2-离开，3-办事开始，4-办事结束
 * @param {*} actionId 操作标识：即单据标识，登录和离开时为空
 * @param {*} beginTime 开始时间
 * @param {*} actionStatus 操作状态：0-成功，1-失败
 */
export const setActionInfo = (actionType, actionId = '', beginTime, actionStatus = 0) => {
  try {
    // 数鲤通改造，数鲤通不采集信息
    if (!mpSdk.env.isZlb) return;

    if (!beginTime) return;

    const endTime = new Date();

    const actionInfo = {
      actionType,
      actionId,
      actionDuration: endTime - beginTime, // 操作时长
      actionStatus,
    };

    printUserLog(actionInfo);
  } catch (error) {
    console.log('err', error);
  }
};

/**
 * 聚合数组
 * @param list 目标数据
 * @param unionBy 聚合的key
 * @param unionTarget 聚合目标
 * @param initValue 初始值
 * @returns
 */
export const unionArray = (arr = [], unionBy, unionTarget, initValue = 0) => {
  const list = cloneDeep(arr);
  const listSet = new Set();
  list?.forEach(element => {
    listSet.add(element[unionBy]);
  });
  const keyList = Array.from(listSet);
  const result = keyList?.map(key => {
    const currentList = list.filter(item => item[unionBy] === key);
    const total = currentList.reduce((sum, ele) => {
      if (ele[unionTarget]) {
        return NP.plus(sum, ele[unionTarget] || 0);
      } else {
        return sum;
      }
    }, initValue);
    const firstIndex = currentList[0];
    const temp = cloneDeep(firstIndex);
    temp[unionTarget] = total;
    temp['indexNo'] = uuidv4();
    return temp;
  });
  return result;
};
/**
 * 聚合费用
 * @param dataList
 */
export const unionExpenseFee = (dataList = []) => {
  const keysList = dataList?.map(item => Object.keys(item));
  const keys = union(...keysList);
  const unionExpense = {};
  keys?.forEach(item => {
    dataList?.forEach(fee => {
      if (!unionExpense[item]) {
        unionExpense[item] = { ...fee[item] };
      } else {
        if (['totalMixCost', 'totalTeachersCost'].includes(item)) {
          const { totalAmount = 0 } = item || {};
          unionExpense[item]['totalAmount'] = NP.plus(
            unionExpense[item]['totalAmount'] || 0,
            totalAmount,
          );
        } else {
          const { expenseFeePOS = [], totalAmount = 0 } = fee[item] || {};
          unionExpense[item]['expenseFeePOS'] =
            unionExpense[item]['expenseFeePOS'].concat(expenseFeePOS);
          unionExpense[item]['totalAmount'] = NP.plus(
            unionExpense[item]['totalAmount'],
            totalAmount,
          );
        }
      }
    });
  });
  return unionExpense;
};

/**
 * 转换费用格式
 * @param expenseFeeExtendPOS
 * @returns
 */
export const transExpenseFeePOS = expenseFeeExtend => {
  const expenseFeeExtendPOS = [];
  for (const key in expenseFeeExtend) {
    if (expenseFeeExtend[key]?.expenseFeePOS?.length > 0) {
      const copyExpenseFeeExtendPOS = { ...expenseFeeExtend[key] };
      for (const item of copyExpenseFeeExtendPOS.expenseFeePOS) {
        item.feeType = ['number', 'string'].includes(typeof item.feeType)
          ? item.feeType
          : item.feeType[1];
      }
      expenseFeeExtendPOS.push(copyExpenseFeeExtendPOS);
    }
  }
  return expenseFeeExtendPOS;
};

/**
 * 服务器费用数据转换组件使用的费用数据
 * @param expenseFormROS
 */
export const costDataTrans = (initFee, expenseFormROS, FEE_PARENT_TYPE) => {
  const feeList = initFee;
  expenseFormROS?.forEach(ele => {
    feeList[FEE_PARENT_TYPE[ele.feeParentType]] = {
      ...ele,
      indexNo: uuidv4(),
      expenseFeePOS: ele.expenseFeeROList?.map(d => ({
        ...d,
        indexNo: ele.feeCode || uuidv4(),
      })),
      expenseFeeROList: undefined,
    };
  });
  return feeList;
};

/**
 * window.open 兼容浙政钉
 * @param url 跳转地址（完整路径）
 */
export const windowOpenIncludeZzd = url => {
  if (mpSdk.env.isZzd) {
    window?.zzd?.openLink({
      url: `${url}?ddtab=true`,
    });
    return;
  }
  window.open(url);
};

/**
 * 格式化地址文件
 * @param treeList
 * @param level
 * @param maxLevel
 * @returns
 */
export const setSpecifiedLevelTree = (treeList, level, maxLevel) => {
  if (!treeList?.length) return;
  treeList?.forEach(item => {
    if (level >= maxLevel) {
      item.children = [];
    }
    item.label = item.name;
    item.value = item.code || item.key;
    if (item.children?.length) {
      setSpecifiedLevelTree(item.children, level + 1, maxLevel);
    }
  });
};

/**
 * 级联组件搜索
 * @param inputValue
 * @param path
 * @returns
 */
export const cascaderSerchFilter = (inputValue, path) => {
  return path[path.length - 1]?.label?.indexOf(inputValue) > -1;
};

/**
 * 获取人员默认部门信息
 * @param departmentList 正常下拉数据
 * @param treeFlag 是否跨部门
 * @param deptId 编辑或再次发起带入的部门Id
 * @param deptName 编辑或再次发起带入的部门name
 * @returns
 */
export const getDefaultDept = (departmentList, treeFlag, deptId, deptName) => {
  const { deptId: firstDepId, fullName } = get(departmentList, '[0]') || {};
  const hasDeptId = departmentList?.some(v => v.deptId === deptId);
  const initialDeptId = treeFlag ? deptId || firstDepId : hasDeptId ? deptId : firstDepId;
  return {
    deptId: initialDeptId,
    deptName: deptName || fullName,
  };
};

export const renderUserName = (user, operatorEnableAlias = false) => {
  return `${
    user.displayName ||
    user.userName ||
    user.operatorName ||
    user.name ||
    user.realName ||
    user.buyerName
  }${operatorEnableAlias && user.nickName ? `（${user.nickName}）` : ''}${
    !get(user, 'type') || get(user, 'hideOperatorShowType')
      ? ''
      : MEMBER_TAGS_ENUM[get(user, 'type')]?.renderTag
  } `;
};
// 从fileID获取URL
export const getFileUrl = async (fileId, callback) => {
  const res = await Upload.getFileUrl({
    fileId,
    bizCode: BIZ_CODE,
  });
  if (res) {
    callback?.(res);
  }
};

export const printPDF = async (
  form_code,
  printBusinessType,
  subType = undefined,
  extraObj = {},
) => {
  if (extraObj?.changeModelLoading) {
    extraObj.changeModelLoading(true);
  }
  const { fileId } = await query('/zlb/api/expense/print', {
    method: 'post',
    data: {
      printBusinessType,
      context: {
        form_code,
      },
      subType,
      isLandscapeOrientation: false, // 是否横屏打印 false-纵向
    },
  });
  getFileUrl(fileId, async res => {
    if (extraObj?.changeModelLoading) {
      extraObj.changeModelLoading(false);
    }
    printJS({
      printable: res,
      type: 'pdf',
    });
  });
};
export const previewPDF = async (form_code, printBusinessType, subType?) => {
  const { fileId } = await query('/zlb/api/expense/print', {
    method: 'post',
    data: {
      printBusinessType,
      context: {
        form_code,
      },
      subType,
      isLandscapeOrientation: false, // 是否横屏打印 false-纵向
    },
  });
  getFileUrl(fileId, async res => {
    window.open(res);
  });
};
/**
 * 触发下载
 * @param ele
 * @param url
 */
export const triggerDownload = (ele, url) => {
  const elink = document.createElement('a');
  elink.download = ele.name;
  elink.style.display = 'none';
  elink.href = url;
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(url);
  document.body.removeChild(elink);
};

/**
 * 列表页排序，根据排序数组顺序排序
 * @param orderArr 排序数组，传每一列的key
 * @param oldColumns 原列表页
 */
export const sortColumns = (orderArr = [] as string[], oldColumns = [] as any[]) => {
  if (!orderArr || !Array.isArray(orderArr)) {
    return oldColumns;
  }

  const newColumns = [];

  for (const item of orderArr) {
    const colunmnObj = oldColumns.find(u => u.key === item);
    if (colunmnObj) {
      newColumns.push(colunmnObj);
    }
  }

  return newColumns;
};

// 清空Url搜索项且不刷新页面
export const removeUrlSearchParams = () => {
  const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

  // 使用 history.pushState 方法修改浏览器历史记录，但不刷新页面
  window.history.pushState({}, '', newUrl);
};

/**
 * 计算剩余收款金额
 * @param allList
 * @param index
 */
export const calculatorLastAmount = (allList, index, feeTotalAmount) => {
  const emptyList = allList?.filter(v => !v.amount);
  // 当前大于一条收款数据，且编辑的剩最后一条金额进行计算
  if (allList.length > 1 && emptyList?.length == 1) {
    const targetIndex = allList?.findIndex(v => v.indexNo === emptyList[0]?.indexNo);
    // 编辑当前条收款金额不算
    if (targetIndex === index) return;
    const lastTarget = allList[targetIndex];
    // 注意amount元和分是否需要转换
    const totalAmount = NP.plus(0, ...allList?.map(v => v.amount || 0));
    const newAmount = NP.times(totalAmount || 0, 100);
    const minusAmount = NP.minus(feeTotalAmount, newAmount);
    lastTarget.amount = minusAmount < 0 ? lastTarget.amount : NP.divide(minusAmount || 0, 100);
  }
};

// 格式化数字成为金额展示,每3位用逗号分隔,精确到分
export const formatNumber = num => {
  if (isNaN(num)) return 0;
  return Number(num / 100)
    .toFixed(2)
    .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
};

// 获取默认初始时间
export const getTimeInitialValue = (beginOption = [], endOption = []) => {
  const [beginTimes, beginPeriod] = beginOption;
  const [endTimes, endPeriod] = endOption;
  const hour = moment().hour().valueOf();
  const todayFormat = moment().format('YYYY-MM-DD');
  const period = hour < 12 ? 1 : hour >= 18 ? 3 : 2;
  const periodValue = hour < 12 ? 0 : hour >= 18 ? 18 : 12;
  const today = moment(todayFormat).hour(periodValue).valueOf();
  const todayEnd = moment(todayFormat)
    .hour(periodValue > 12 ? periodValue : NP.plus(periodValue, 6))
    .valueOf();
  // 技术时间标识
  const periodEnd = periodValue > 12 ? TIME_TAG.Evening : TIME_TAG.Afternoon;
  return {
    begin: [beginTimes || today, beginPeriod === -1 ? period : beginPeriod || period],
    end: [endTimes || todayEnd, endPeriod === -1 ? periodEnd : endPeriod || periodEnd],
  };
};

/**
 * 判断是否至少含有一个对应的属性
 * @param obj
 * @param properties
 */
export const hasObjectProperty = (obj: Object, properties: Array<String>) => {
  // 过滤出非空属性
  const hasObject = pickBy(obj, item => {
    return !!item;
  });
  // 交集大于0说明至少有个属性有值
  return intersection(Object.keys(hasObject), properties).length > 0;
};

// 环境名称
export const envName = !mpSdk.env.isZlb ? '数智财务' : '浙里报';

/**
 * 删除url参数
 */
export const removeParamFromUrlAndReload = () => {
  const urlParts = location.href?.split('?');
  const newUrl = urlParts[0];

  if (urlParts[1]) {
    const queryParams = getQueryParams(urlParts[1]) || {};
    if (queryParams.businessType && queryParams.businessCode) {
      location.replace(newUrl);
    }
    if (queryParams.businessCode && queryParams.tabKey) {
      location.replace(newUrl);
    }
  }
};

export function trim(str) {
  if (!str) {
    return '';
  }
  if (/^([a-zA-Z]:)?(\\[a-zA-Z0-9_-]+)+\\?/.test(str)) {
    const tmp = str.split('\\');
    str = tmp[tmp.length - 1];
  }
  return str.replace(/ /g, '').replace(/,/g, '').replace(/\$/g, '');
}

/**
 * 过滤特殊符号
 * @param str
 * @returns
 */
export function trimSpec(str, defaultName = '未命名') {
  const reg = new RegExp(
    "[`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]",
  );
  let st = '';
  for (let i = 0; i < str.length; i++) {
    st += str.substr(i, 1).replace(reg, '');
  }
  // 过滤后如果没有文件名， 则设置一个文件名
  const fileNameArr = st.split('.');
  if (fileNameArr.length === 2 && !fileNameArr[0]) {
    fileNameArr[0] = defaultName;
  }
  return fileNameArr.join('.');
}
/**
 * 裁剪文件名称的最大长度
 * 过滤特殊字符
 * 如果超出，则自动裁剪
 */
export const cutFileName = (name, maxLength) => {
  let filename = trim(name);
  if (filename.length > maxLength) {
    const splitArray = filename.split('.');
    const len = splitArray.length;
    const suffix = splitArray[len - 1]; // 后缀
    const nameLength = maxLength - (suffix.length + 1);
    filename = `${name.substring(0, nameLength)}.${suffix}`;
  }
  return filename;
};

/**
 * 附件信息入参字段处理
 * @param {*} attachments
 * @returns
 */
export function formateAttachmentList(attachments) {
  return (attachments || [])?.map(({ fileId, type, name, size, subBizType }) => ({
    fileId,
    type: type || name?.split('.').pop(),
    name: cutFileName(trimSpec(name), 128),
    size,
    bizCode: BIZ_CODE,
    subBizType,
  }));
}
export function formateAttachmentListBiztype(attachments) {
  return (attachments || [])?.map(({ fileId, type, name, size, subBizType }) => ({
    fileId,
    type: type || name?.split('.').pop(),
    name: cutFileName(trimSpec(name), 128),
    size,
    bizCode: BIZ_CODE,
    subBizType,
  }));
}
// 获取百搭表单实例
export const getBaidaFormInstance: (r: any) => WrappedFormUtils = ref => {
  if (!ref?.current) return;
  const key = Object.keys(ref.current?.schemaRenderRef?.instanceList || {}).find(item =>
    item.includes('FcFormGrid'),
  );
  const form: WrappedFormUtils = ref.current?.schemaRenderRef?.instanceList?.[key];
  return form;
};

export const allSettled = promises => {
  if (mpSdk.env.isZzd || mpSdk.env.isApp) {
    return Promise.all(
      promises.map(p =>
        p
          .then(value => ({
            status: 'fulfilled',
            value,
          }))
          .catch(reason => ({
            status: 'rejected',
            reason,
          })),
      ),
    );
  } else {
    return Promise.allSettled(promises);
  }
};

// 递归替换树的key
export const mapKeyOfTree = (tree, maps) => {
  const res = tree.map(item => {
    if (item.children && !isEmptyFromLodash(item.children)) {
      item.children.forEach(ele => {
        ele.parentId = item.id;
        ele.parentName = item.name;
      });
      const t = mapKeyOfTree(item.children, maps);
      item.children = t;
    }
    return mapKeys(item, (_, key) => {
      return maps[key] || key;
    });
  });
  return res;
};

// 发票过滤提示
// ALREADY_EXPENSE(10002, "该票据已被其他报销单使用"),
// COMPLETE(10003, "该票据已完结"),
// NOT_EXISTS(10004, "该票据不存在"),
// HAS_BEEN_COLLECT(10005,"该票据已被他人保存"),
// REPEAT_INVOICE(10007,"重复票据") // 跨省票新增code
export const filterInvoiceError = invoiceCheckResultROS => {
  const alreadyList = (invoiceCheckResultROS || []).filter(
    v => !v.success && v.code === STRONG_CONTROL_CODE.ALREADY_EXPENSE,
  );
  const completeList = (invoiceCheckResultROS || []).filter(
    v => !v.success && v.code === STRONG_CONTROL_CODE.COMPLETE,
  );
  const notExistsList = (invoiceCheckResultROS || []).filter(
    v => !v.success && v.code === STRONG_CONTROL_CODE.NOT_EXISTS,
  );
  const hasBeenList = (invoiceCheckResultROS || []).filter(
    v => !v.success && v.code === STRONG_CONTROL_CODE.HAS_BEEN_COLLECT,
  );
  const repeatInvoice = (invoiceCheckResultROS || []).filter(
    v => !v.success && v.code === STRONG_CONTROL_CODE.REPEAT_INVOICE,
  );
  const hasErrorInvoiceLength =
    alreadyList.length ||
    completeList.length ||
    notExistsList.length ||
    hasBeenList.length ||
    repeatInvoice.length;
  const msg =
    alreadyList[0]?.msg ||
    completeList[0]?.msg ||
    notExistsList[0]?.msg ||
    hasBeenList[0]?.msg ||
    repeatInvoice[0]?.msg;
  return {
    status: hasErrorInvoiceLength > 0,
    length: hasErrorInvoiceLength,
    msg,
  };
};

export const dfsFindItem = (code, tree, customKey = '') => {
  const key = customKey || 'value';
  if (isEmpty(tree) || !code) return {};

  for (const item of tree) {
    if (item[key] === code) {
      return item;
    }
    if (item.children) {
      const result = dfsFindItem(code, item.children, customKey);
      if (result) {
        return result;
      }
    }
  }
};
/**
 * 格式化银行卡号
 * @param accountNumber
 * @returns
 */
export const maskBankAccount = accountNumber => {
  if (!accountNumber || accountNumber.length < 8) return accountNumber;
  return accountNumber.replace(/(\d{4})\d{4}(\d{4})/, '$1****$2');
};

export const zlbFormatCentToYuan = amount => {
  if (isNil(amount)) return '-';
  if (amount === 0) return '0.00';
  return formatCentToYuan(amount);
};

/**
 *
 * 检查ua，判断浙政钉版本是否低于2.21.8.5
 *
 * */
export const checkVersion = async (compireVersion = '2.21.8.5') => {
  // 获取navigator.userAgent字符串
  const userAgent = await window?.zzd?.getUserAgent();
  // 如果版本号一样，直接返回true 兼容后续版本号比较逻辑，防止版本号一致时判断为false
  if (userAgent?.version === compireVersion) return true;

  // 将版本号字符串按点分割成数组，方便后续比较
  const chromeVersionArray = userAgent?.version?.split('.') || [];
  // 设要比较的目标版本号
  const targetVersionArray = compireVersion.split('.') || [];
  // 比较版本号的大小
  let isGreater = false;

  for (let i = 0; i < chromeVersionArray.length; i++) {
    const firstNum = parseInt(chromeVersionArray[i]) || 0;
    const secondNum = parseInt(targetVersionArray[i]) || 0;
    if (firstNum === secondNum) {
      continue;
    } else {
      if (firstNum > secondNum) {
        isGreater = true;
      } else {
        isGreater = false;
      }
      break;
    }
  }
  return isGreater;
};

/**
 * 多个时间段计算有效天数
 */
export const calculateValidDays = dateRanges => {
  const allDates = [];
  dateRanges.forEach(range => {
    const [start, end] = range || [];
    if (start && end) {
      const startDate = moment(start).startOf('day');
      const endDate = moment(end).endOf('day');
      let currentDate = startDate;
      while (currentDate.isBefore(endDate)) {
        allDates.push(moment(currentDate).format('YYYY-MM-DD'));
        currentDate = currentDate.add(1, 'd');
      }
    }
  });
  return uniq(allDates)?.length;
};

/**
 *
 * @param time ms
 * @returns
 */
export const sleep = (time = 1000) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

/**
 * 根据 key 路径查找节点（根是数组）
 * @param {Array<Object>} rootArray  根数组
 * @param {Array<string|number>} path  路径
 * @param {string} childrenKey  子节点数组的字段名，默认 'children'
 * @returns {Object|null}
 */
export const findNodeByPath = (rootArray, path, childrenKey = 'children') => {
  if (!Array.isArray(rootArray) || !Array.isArray(path) || path.length === 0) return null;

  let nodes = rootArray; // 当前层节点数组
  let currentNode = null;
  for (let index = 0; index < path.length; index++) {
    const key = path[index];
    const node = nodes.find(n => n.key === key);
    if (!node) return null;
    currentNode = node;
    if (index < path.length - 1) {
      nodes = node[childrenKey] || []; // 进入下一层
    }
  }
  return currentNode;
};

export const formatStartAndEndTime = (time, type) => {
  let result = undefined;

  if (type === 'start') {
    result = time ? moment(time).startOf('day').valueOf() : null;
  }

  if (type === 'end') {
    result = time ? moment(time).endOf('day').valueOf() : null;
  }

  return result;
};
export const jsonParse = str => {
  return isJSON(str) ? JSON.parse(str) : str;
};

/**
 * 格式化手机号
 * @param phoneNumber
 * @returns
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return phoneNumber;
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
};

/**
 * 格式化身份证号
 * @param idCard
 * @returns
 */
export const formatIdCard = (idCard: string): string => {
  if (!idCard) return '';
  // 验证是否为有效的身份证号格式
  const isValidIdCard = rex18.test(idCard) || rex15.test(idCard);
  if (!isValidIdCard) {
    console.warn('Invalid ID card number');
    return idCard;
  }

  // 18位身份证号：显示前6后4
  if (idCard.length === 18) {
    return idCard.replace(/(\d{6})\d{8}(\d{4})/, '$1********$2');
  }

  // 15位身份证号：显示前6后3
  if (idCard.length === 15) {
    return idCard.replace(/(\d{6})\d{6}(\d{3})/, '$1******$2');
  }

  return idCard;
};

/**
 * 格式化邮箱地址
 * @param email 邮箱地址
 * @returns 格式化后的邮箱地址，@前最多显示3位字符，@后完整显示
 */
export const formatEmail = (email: string): string => {
  if (!email) return '';

  const atIndex = email.indexOf('@');

  // 如果没有找到@符号或者@在开头，则认为不是有效邮箱，直接返回
  if (atIndex <= 0) {
    return email;
  }

  // @前的字符
  const prefix = email.substring(0, atIndex);
  // @后的字符
  const suffix = email.substring(atIndex);

  // 如果@前字符长度小于等于3，直接返回
  if (prefix.length <= 3) {
    return email;
  }

  // 只保留前3位字符，其余用*替代
  const visiblePart = prefix.substring(0, 3);
  return `${visiblePart}****${suffix}`;
};

// 转换 Key 值， 获取最后 . 后面的字符串作为 Key
export const transObjKey = (obj = {}) => {
  if (Object.prototype.toString.call(obj) !== '[object Object]') return {};
  return Object.keys(obj).reduce((concatObj, nextKey) => {
    const tempKey = nextKey.replace(/.*\./, '');
    return { ...concatObj, [tempKey]: obj[nextKey] };
  }, {});
};

//
export const loopTransArr = ({ arr = [], childrenKey = 'children', trans }) => {
  return arr.map(item => {
    if (item?.[childrenKey]?.length) {
      item[childrenKey] = loopTransArr({ arr: item[childrenKey], childrenKey, trans });
    }
    return trans?.(item);
  });
};
